module.exports = __webpack_public_path__ + "img/weight-lift-2.2ec15b1a.svg";